import Slider from '../Elements/Slider';

/**
 * GallerySlider
 */
export default class GallerySlider extends Slider {
  constructor($element) {
    super($element);

    this.$element = $element;

    this.initialize({
      margin: 30,
      responsive: {
        0: {
          margin: 15
        },
        640: {
          margin: 30
        }
      }
    });
  }
}
